import { render, staticRenderFns } from "./dashboardD.vue?vue&type=template&id=a0aa06a2&"
import script from "./dashboardD.vue?vue&type=script&lang=js&"
export * from "./dashboardD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports